import React from 'react';
import Dashboard from '../components/Dashboard/Dashboard';

const DashboardPage: React.FC = () => {
  return (
    <div className="dashboard-page">
      <Dashboard />
    </div>
  );
};

export default DashboardPage;
